module.exports = __webpack_public_path__ + "img/3.c6c40789.png";